import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';


const Container = styled.div`
	position: fixed;
	bottom: 8px;
	left: ${props => props.pageListOpen ? '350px' : '0px'};
	right: ${props => props.controlsOpen ? '350px' : '0px'};
	display: flex;
	flex-direction: row;
	justify-content: center;
	opacity: 0.75;
	transition: opacity 0.2s ease-out;

	&:hover {
		opacity: 1;
	}
`;

const Page = styled(Link)`
	background-color: ${props => props.active === 1 ? '#4A90E2' : 'white'};
	color: ${props => props.active === 1 ? 'white' : '#4A90E2'};
	width: 24px;
	height: 24px;
	border-radius: 12px;
	margin-right: 16px;
	text-decoration: none;
	font-size: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 2px 4px rgba(0,0,0,0.3);

	&:ngh-last-child(1) {
		margin-right: 0px;
	}
`;

const Pagination = props => {
	const { lng, activePage, brochureId, pages } = props;
	return (
		<Container controlsOpen={props.controlsOpen} pageListOpen={props.pageListOpen}>
			{pages.map((page, pageIndex) => {
				return (
					<Page
						key={page.id}
						onClick={() => props.activeSlotHandler(null)}
						to={`/${lng}/t/brochure/${brochureId}/${page.id}/`}
						active={activePage === page.id ? 1 : 0}
					>
						{ pageIndex + 1 }
					</Page>
				)
			})}
		</Container>
	)
}

Pagination.propTypes = {
	lng: PropTypes.string,
	activePage: PropTypes.any,
	brochureId: PropTypes.string,
	pages: PropTypes.array,
	controlsOpen: PropTypes.bool,
	pageListOpen: PropTypes.bool,
	activeSlotHandler: PropTypes.func,
}

export default translate('translations')(Pagination);
